import { useState, useEffect } from "react";

import PaymentCards from "../PaymentCards/PaymentCards";
import { useFormik } from "formik";
import PaymentMethodPageSection from "../Layout/PaymentMethodPageSection";
import { useContext } from "react";
import Context from "../../../context";
import axios from "axios";
import { API_URL } from "../../data/constants";

export default function PaymentMethods() {
  let userRole = localStorage.getItem("userRole");
  const [paymentView, setPaymentView] = useState(userRole === "IT-User" ? "bank" : "card");
  const {contextState, setContextState} = useContext(Context);
  const [stateValue, setStateValue] = useState(1);
  const [allowBankDraft, setAllowBankDraft] = useState(true);

  let account = contextState.currentAccount;
  
  useEffect(() => {
    setAllowBankDraft(contextState.currentAccount.allowBankDraft);
    
    if (contextState.paymentMethodsChanged === true)
      setTimeout(() => {
        setContextState({ ...contextState, paymentMethodsChanged: false });
      }, 2000);
  }, [contextState.paymentMethodsChanged]);

  function validate(values) {
    const errors = {};

    if (values.address1 === "")
      errors.address1 = "Address Line 1 is a required field";
    if (values.city === "") errors.city = "City is a required field";
    if (values.zipCode === "") errors.zipCode = "Zip Code is a required field";
    if (paymentView === "bank") {
      if (values.bankRoutingNumber.length < 9)
        errors.bankRoutingNumber = "Must be 9 numbers long";
      else if (!values.bankRoutingNumber) errors.bankRoutingNumber = "Required";
     /* if (values.bankAccountNumber.length < 9) 
        errors.bankAccountNumber = "Must be at least 9 numbers long";*/
      else if (!values.bankAccountNumber) errors.bankAccountNumber = "Required";
      
      if (values.reAccountNumber !== values.bankAccountNumber)
        errors.reAccountNumber = "Account numbers must match";
    }

    if (paymentView === "card") {
      if(!values.firstName) errors.firstName = "Required"
      if (!values.creditCardNumber) errors.creditCardNumber = "Required";
      if (!values.creditCardCode) errors.creditCardCode = "Required";
      if (!values.expirationDate) errors.expirationDate = "Required";
    }

    if(!values.accountName) errors.accountName = 'Required'
    if(!values.billingAddress) errors.billingAddress = 'Required'
    if(!values.billingAddressCity) errors.billingAddressCity = 'Required'
    if(!values.billingAddressZipCode) errors.billingAddressZipCode = 'Required'

    return errors;
  }

  const addMethodForm = useFormik({
    initialValues: {
      businessName: "",
      firstName: "",
      lastName: "",
      billingAddress: "",
      billingAddressCity: "",
      billingAddressStateId: 1,
      billingAddressZipCode: "",
      authorizeProfileId: "",
      authorizeMethodId: "",
      paymentMethodProcessingType: 0,
      creditCardSelected: false,
      bankAccountSelected: false,
      creditCardNumber: "",
      expirationDate: "",
      creditCardCode: "",
      bankAccountNumber: "",
      reAccountNumber: "",
      bankRoutingNumber: "",
      bankName: "",
      bankNameOnAccount: "",
      emailAddress: localStorage.getItem("username"),
      createdBy: localStorage.getItem("username"),
    },
    validate,
    onSubmit: (values) => {
      values.customerId = account.contract.customerId;
      values.masterCustomerId = null;
      values.customerNumber = account.customerNumber;
      values.businessName = account.customerName;

      let acctName = values.accountName.split(" ");

      values.firstName = acctName[0];
      values.lastName = acctName[1];

      if (paymentView === "card") {
        values.creditCardSelected = true;
        values.bankAccountSelected = false;
      } else {
        values.creditCardSelected = false;
        values.bankAccountSelected = true;
      }

      if (values.creditCardSelected) {
        values.bankAccountNumber = null;
        values.bankRoutingNumber = null;
        values.bankName = null;
        values.bankNameOnAccount = null;
      }
      if (values.bankAccountSelected) {
        values.creditCardNumber = null;
        values.expirationDate = null;
        values.creditCardCode = null;
      }
      delete values.reAccountNumber;

      values.billingAddressStateId = stateValue;

      if (values.bankAccountNumber && values.bankAccountNumber.length < 9) {
        let zerosToAdd = 9 - values.bankAccountNumber.length;
        let zeroPadStr = "";
        for (let i = 0; i < zerosToAdd; i++) {
          zeroPadStr += "0";
        }
        values.bankAccountNumber = zeroPadStr + values.bankAccountNumber;
      }
      
      axios
        .post(API_URL + "/Payments/PaymentMethod", values, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          let data = {
            type: "message",
            title: res.data.title,
            content: res.data.message,
          };
          setContextState({ ...contextState, modal: data, paymentMethodsChanged: true });
        })
        .catch((err) => {
          console.error(err);
        });
      //setContextState({ ...contextState, paymentMethodsChanged: true });

      delete values.accountName;
      delete values.creditCardSelected;
      delete values.bankAccountSelected;
    },
  });
  
  return (
    <div className="individual-wrapper">
      <div className="individual-header">
        <h1>Payment Methods</h1>
      </div>
      <div className="page-section">
        <PaymentCards canRemove />
      </div>
      <form onSubmit={addMethodForm.handleSubmit}>
        <PaymentMethodPageSection
          form={addMethodForm}
          hasExisting={false}
          title="Add New Payment Method"
          defaultView={paymentView}
          paymentView={paymentView}
          setPaymentView={setPaymentView}
          setValue={setStateValue}
          allowBankDraft={allowBankDraft}
        />
      </form>
    </div>
  );
}
